import NotificationsManager from './NotificationsManager'
import { connect } from 'react-redux'
import notifications from '../../dataStore/actions/notifications'

const mapStateToProps = ({ notifications }) => ({
  notifications: notifications.list
})

const mapDispatchToProps = (dispatch) => ({
  addNotification: (notification) => dispatch(notifications.addNotification(notification.text, notification.time))
})
export default connect(mapStateToProps, mapDispatchToProps)(NotificationsManager)
